// node_modules
import { FC, useContext, useEffect, useState } from "react";
// Components
import { TechnologyRate, TechnologyVote } from "Components";
// Constants
import { CasePhaseConstants } from "Constants";
// Contexts
import { CaseContext } from "Stores";
import { DeliveryLayoutContext } from "Providers";
// Types
import { TTechnology } from "Types";
// styles
import tileStyles from "../../tileSidebarMenuItem.module.scss";

export const VoteOrRateTile: FC = () => {
    // State
    const [currentTechnology, setCurrentTechnology] = useState<TTechnology | undefined>(undefined)

    // Contexts
    const { caseState } = useContext(CaseContext);
    const {
        isRightSidebarCollapsed,
        setIsOnRightSidebarHoverCollapsed,
        isOnRightSidebarHoverCollapsed
    } = useContext(DeliveryLayoutContext);

    // Logic
    useEffect(() => {
        if (!caseState.conceptTechnologyList || !caseState.selectedTechnologyId) return;

        for (const concept of caseState.conceptTechnologyList.concepts) {
            for (const technology of concept.technologies) {
                if (technology.id === caseState.selectedTechnologyId) {
                    setCurrentTechnology(technology);
                    break;
                }
            }
        }

        if (caseState.conceptTechnologyList.additionalTechnologies) {
            for (const userAddedTechnology of caseState.conceptTechnologyList.additionalTechnologies) {
                if (userAddedTechnology.id === caseState.selectedTechnologyId) {
                    setCurrentTechnology(userAddedTechnology);
                    break;
                }
            }
        }

    }, [caseState.conceptTechnologyList, caseState.selectedTechnologyId]);

    const handleOnClick = (): void => {
        if(isRightSidebarCollapsed) {
            setIsOnRightSidebarHoverCollapsed(!isOnRightSidebarHoverCollapsed);
        }
    };
    
    return (
        <div id="vote-or-rate-tile"> 
            <button className={[tileStyles.menuItem, tileStyles.voteTile].join(" ")} onClick={handleOnClick}>
                <img src={"/images/tileSidebarImageVote.png"} alt={"Vote"} />
                {currentTechnology ?
                    caseState.casePhase === CasePhaseConstants.PHASE_1.toLowerCase() ?
                        <TechnologyVote additionalClassName={tileStyles.technologyVotingContainer} technology={currentTechnology} />
                        :
                        <TechnologyRate additionalClassName={tileStyles.technologyRatingContainer} technology={currentTechnology}
                            isEditMode={true} techRate={currentTechnology.rates?.currentUserRate} />
                    : 
                        <>
                        </>
                }
            </button>
        </div>
    );
}